"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryTickerWithSymbolList = exports.toSymbol = exports.convertState2 = void 0;
const decimal_js_1 = require("decimal.js");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const webSocket_1 = require("rxjs/webSocket");
const trade_token_lib_1 = require("trade_token_lib");
const trade_utils_lib_1 = require("trade_utils_lib");
const ExchangeID_1 = require("../ExchangeAPI/ExchangeID");
const TradeTypeDef_1 = require("../ExchangeAPIAdapter/TradeTypeDef");
const OrderDescUtils_1 = require("../MarketTradeDesc/OrderDescUtils");
const Macro_1 = require("../Tools/Macro");
const TradeUtils_1 = require("../Tools/TradeUtils");
const BaseWebSocket_1 = require("../websocket/BaseWebSocket");
const ExchangeWebSocket_1 = require("../websocket/ExchangeWebSocket");
class BaseTradingApi {
    constructor(apiKey) {
        this.symbols = null;
        this.symbolMap = new Map();
        this.refreshRightNow = new rxjs_1.Subject();
        this.tradeExchangeInfo = undefined;
        this.stopRefreshGridDetail = false;
        this.apiKey = apiKey;
        this.extraParamRuntime = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost();
        this.defaultSymbols = [];
        if (apiKey) {
            this.tradeExchangeInfo = TradeUtils_1.TradeUtils.loadTradeExchangeInfo(apiKey.market);
        }
        this.keyResolver = (0, trade_token_lib_1.acquireKeyResolver)();
    }
    getInnerApiKeyInfo() {
        return this.apiKey;
    }
    saveOrderFavParams(type, title, data) {
        throw new Error("Method not implemented.");
    }
    deleteOrderFavParams(id, type) {
        throw new Error("Method not implemented.");
    }
    orderFavParamsList(type) {
        throw new Error("Method not implemented.");
    }
    // 获取资金池可借贷资金
    queryDeptAvaliable(coin) {
        throw new Error("Method not implemented.");
    }
    // 获取杠杆交易信息
    queryLeverageTradeInfo(base, quote) {
        throw new Error("Method not implemented.");
    }
    // 获取杠杆网格资金费率
    queryFutureFundingRate(base, quote, exchange) {
        throw new Error("Method not implemented.");
    }
    // 获取支持杠杆交易的配置文件
    queryLeverageSupportedConfig() {
        throw new Error("Method not implemented.");
    }
    //////////////////////////////////////////////////////资产API////////////////////////////////////////////////
    requestCoinAddress(coin) {
        throw new Error("Method not implemented.");
    }
    requestMoveRecords(coin) {
        throw new Error("Method not implemented.");
    }
    fetchDepositWithdrawHistory(coin, type, startTime) {
        throw new Error("Method not implemented.");
    }
    fetchDepositWithdrawHistoryV2(coin, type, startTime) {
        throw new Error("Method not implemented.");
    }
    withdraw(param) {
        throw new Error("Method not implemented.");
    }
    withdrawV2(param) {
        throw new Error("Method not implemented.");
    }
    cancelWithdraw(id) {
        throw new Error("Method not implemented.");
    }
    requestAllBrokerCoins() {
        throw new Error("Method not implemented.");
    }
    requestAllBrokerCoinsV2() {
        throw new Error("Method not implemented.");
    }
    parseProtocolToDisplay(coinName, protocol) {
        throw new Error("Method not implemented.");
    }
    fetchVerifyCode(verifyCodeType) {
        throw new Error("Method not implemented.");
    }
    // 追加/提取保证金
    transferMargin(orderType, orderId, param) {
        throw new Error("not implemented");
    }
    queryTransferRecord(orderType, orderId) {
        throw new Error("Method not implemented.");
    }
    queryTransferRecordV2(params) {
        throw new Error("Method not implemented.");
    }
    transferProfit(orderType, orderId, param) {
        throw new Error("Method not implemented.");
    }
    queryCurrentDayProfitAndLoss() {
        throw new Error("Method not implemented.");
    }
    changeOrderTriggerPrices(params) {
        throw new Error("Method not implemented.");
    }
    querySLProOrderList(params) {
        throw new Error("Method not implemented.");
    }
    queryBotExchangeCloseOrderList(orderId, orderType, tag) {
        throw new Error("Method not implemented.");
    }
    getQueryAllMarketBotOrdersMoreV3(params) {
        throw new Error("Method not implemented.");
    }
    queryAllBotOrdersV4(params) {
        throw new Error("Method not implemented.");
    }
    fetchFutureSymbolBalance(symbol) {
        throw new Error("Method not implemented.");
    }
    interruptFsaAdjustPosition(orderType, orderId) {
        throw new Error("Method not implemented.");
    }
    getSpotAndFundTodayInitAsset() {
        throw new Error("Method not implemented.");
    }
    convertStableCoin(source, target, sourceAmount) {
        throw new Error("Method not implemented.");
    }
    querySymbolStatus(symbol) {
        throw new Error("Method not implemented");
    }
    queryCoinTransferInfo() {
        throw new Error("Method not implemented");
    }
    fetchPionexStrategyBalance(strategyId) {
        throw new Error("Method not implemented.");
    }
    querySROrderRecords(param) {
        throw new Error("Method not implemented.");
    }
    querySymbolsStatus() {
        throw new Error("Method not implemented.");
    }
    queryManualOrders(param) {
        throw new Error("Method not implemented.");
    }
    queryBotOrderCount() {
        throw new Error("Method not implemented.");
    }
    getAllReleaseProfit() {
        throw new Error("Method not implemented.");
    }
    modifySRBotName(name, orderType, orderId) {
        throw new Error("Method not implemented.");
    }
    queryDCACustomOrders(orderId, pageToken) {
        throw new Error("Method not implemented.");
    }
    smartRebalanceUpdatePortfolio(orderId, portfolio, allocateOut) {
        throw new Error("Method not implemented.");
    }
    modifySRRules(param, orderType, orderId) {
        throw new Error("Method not implemented.");
    }
    querySRModifyCoinRecord(orderId) {
        throw new Error("Method not implemented.");
    }
    allocateSRSmallBalance(orderId) {
        throw new Error("Method not implemented.");
    }
    fetchFutureSpotIncome(orderId, nexPageToken) {
        throw new Error("Method not implemented.");
    }
    fetchOrderIncomes(orderId, orderType, nexPageToken, incomeTypeIn) {
        throw new Error("Method not implemented.");
    }
    cancelAllOrder(order) {
        return (0, rxjs_1.of)([]);
    }
    getQueryGridCloseOrdersObservable(gridOrderId, limit, orderType) {
        return (0, rxjs_1.of)([]);
    }
    queryGridPairedCloseOrderList(orderId, orderType, pageToken) {
        return (0, rxjs_1.of)(undefined);
    }
    getQueryGridCloseOrdersOnce(gridOrderId, limit, orderType) {
        return (0, rxjs_1.of)([]);
    }
    getQueryGridDescObservable(base, quote, griOrderId) {
        return (0, rxjs_1.of)(undefined);
    }
    getSpotOrder(symbol, id) {
        return (0, rxjs_1.of)(undefined);
    }
    getQueryGridOpenOrdersObservable(gridOrderId, orderType) {
        return (0, rxjs_1.of)([]);
    }
    getQueryMarketAllBotOrders() {
        return (0, rxjs_1.of)([]);
    }
    getQueryByStatusMarketBotOrders() {
        return (0, rxjs_1.of)([]);
    }
    getWebSocketMarketBotOrders(exchange) {
        return (0, rxjs_1.of)([]);
    }
    getQueryByStatusMarketBotOrdersMore(pageNo, pageNum, status, base, quote) {
        return (0, rxjs_1.of)([]);
    }
    getQueryBotOrdersMoreV2(param) {
        return (0, rxjs_1.of)([]);
    }
    getMarketBotOrdersCountByStatus(params) {
        return (0, rxjs_1.of)(0);
    }
    getTickerImpl(base, quote) {
        return (0, rxjs_1.of)(undefined);
    }
    queryOrderById(orderId) {
        return (0, rxjs_1.of)(undefined);
    }
    recoverGridOrder(orderId) {
        return (0, rxjs_1.of)(false);
    }
    refreshTradingLimitInfoWithSymbol(base, quote) { }
    getRefreshTradingLimitInfoObservable(base, quote) {
        return (0, rxjs_1.of)({
            symbol: "",
            base: base,
            quote: quote,
            baseDisplay: base,
            isLeverage: false,
        });
    }
    getTradingLimitForHuoBiPro(base, quote) {
        return this.getRefreshTradingLimitInfoObservable(base, quote);
    }
    queryDepthDataWithRestApi(base, quote) {
        return (0, rxjs_1.of)(undefined);
    }
    queryAIPOrTWAPCustomOrdersOnce(orderId, pgno = 0, pgnm = 10) {
        return (0, rxjs_1.of)([]);
    }
    getBotTypeBalance() {
        return (0, rxjs_1.of)(undefined);
    }
    getQueryAllMarketBotOrdersMoreV2(param, allExchange) {
        return (0, rxjs_1.of)([]);
    }
    queryGridProBalanceSequence(orderType, orderId) {
        return (0, rxjs_1.of)(undefined);
    }
    /**
     * enhanceAip 收益
     * @param orderType
     * @param orderId
     */
    queryGridProBalanceSequenceV2(orderType, orderId) {
        throw new Error("Method not implemented.");
    }
    _toSymbol(base, quote) {
        return base.toUpperCase() + "/" + quote.toUpperCase();
    }
    supportWebSocketDepth() {
        return this.tradeExchangeInfo.webSocket.supportDepth;
    }
    supportWebSocketTicker() {
        return this.tradeExchangeInfo.webSocket.supportTicker;
    }
    supportWebSocketOrder() {
        return this.tradeExchangeInfo.webSocket.supportOrder;
    }
    supportWebSocketTrades() {
        return this.tradeExchangeInfo.webSocket.supportTrades;
    }
    supportBUOrderBookWebSocket() {
        return this.tradeExchangeInfo.webSocket.supportOrderBook;
    }
    shouldCheckStrategyOrder() {
        return (this.checkMarketSupportOrderType(TradeTypeDef_1.ExchangeOrderType.grid) ||
            this.checkMarketSupportOrderType(TradeTypeDef_1.ExchangeOrderType.gridPro) ||
            this.checkMarketSupportOrderType(TradeTypeDef_1.ExchangeOrderType.gridV3) ||
            this.checkMarketSupportOrderType(TradeTypeDef_1.ExchangeOrderType.gridClassic) ||
            this.checkMarketSupportOrderType(TradeTypeDef_1.ExchangeOrderType.ig) ||
            this.checkMarketSupportOrderType(TradeTypeDef_1.ExchangeOrderType.aip) ||
            this.checkMarketSupportOrderType(TradeTypeDef_1.ExchangeOrderType.twap) ||
            this.checkMarketSupportOrderType(TradeTypeDef_1.ExchangeOrderType.gridLoan) ||
            this.checkMarketSupportOrderType(TradeTypeDef_1.ExchangeOrderType.gridLeverage) ||
            this.checkMarketSupportOrderType(TradeTypeDef_1.ExchangeOrderType.gridLeverageShort) ||
            this.checkMarketSupportOrderType(TradeTypeDef_1.ExchangeOrderType.gridFuture) ||
            this.checkMarketSupportOrderType(TradeTypeDef_1.ExchangeOrderType.stopLimit) ||
            this.checkMarketSupportOrderType(TradeTypeDef_1.ExchangeOrderType.trailingStop));
    }
    // 对数据进行格式化
    exchangeSymbolFormatter(symbol) {
        const display = TradeUtils_1.TradeUtils.parseDisplay(symbol.base, symbol.quote, this.apiKey.market);
        const _exchangeSymbol = {
            symbol: symbol.symbol,
            base: symbol.base,
            quote: symbol.quote,
            baseDisplay: display.baseDisplay,
            quoteDisplay: display.quoteDisplay,
            isLeverage: display.isLeverage,
            isSpot: display.isSpot,
            symbolType: display.type,
        };
        let precisionPrice = 8;
        let precisionAmount = 8;
        let precisionCost = undefined;
        if (symbol.precision) {
            if (symbol.precision.price !== undefined) {
                precisionPrice = symbol.precision.price;
            }
            if (symbol.precision.amount !== undefined) {
                precisionAmount = symbol.precision.amount;
            }
            precisionCost = symbol.precision.cost;
        }
        if (symbol.limits) {
            _exchangeSymbol.limit = {
                amount: symbol.limits.amount,
                price: symbol.limits.price,
                cost: symbol.limits.cost || { max: null, min: null },
                spending: symbol.limits.spending || { max: null, min: null },
                dumping: symbol.limits.dumping || { max: null, min: null },
            };
            ///> bittrex cost min
            if (this.apiKey.market === "bittrex" && symbol.quote.toUpperCase() === "BTC") {
                _exchangeSymbol.limit["cost"] = {
                    min: 0.0005,
                    max: undefined,
                };
            }
        }
        ///> 这个确保精度数据不为负数，不然客户端格式化的时候可能会崩溃
        _exchangeSymbol.precision = Math.abs(precisionPrice);
        _exchangeSymbol.amount = Math.abs(precisionAmount);
        _exchangeSymbol.precisionCost = Math.abs(precisionCost);
        return _exchangeSymbol;
    }
    /**
     *
     * @param handleSymbol 中间数据处理回调，避免在外部进行多余的循环处理
     * @returns
     */
    getExchangeSymbols(handleSymbol) {
        return this.getExchangeSymbolsObservable().pipe((0, operators_1.flatMap)((res) => {
            const mappedSymbols = [];
            res.forEach((symbol) => {
                // 筛选
                if (symbol.active === false) {
                    return;
                }
                // 使用原来的数据处理方法
                const originFormattedExchangeSymbols = this.exchangeSymbolFormatter(symbol);
                // 外部数据处理函数
                const exchangeSymbol = typeof handleSymbol === "function" ? handleSymbol(originFormattedExchangeSymbols) : originFormattedExchangeSymbols;
                this.symbolMap.set(`${exchangeSymbol.base}_${exchangeSymbol.quote}`, exchangeSymbol);
                mappedSymbols.push(exchangeSymbol);
            });
            this.symbols = mappedSymbols;
            return (0, rxjs_1.of)(mappedSymbols);
        }));
    }
    setExchangeSymbols(symbols) {
        if (!symbols || symbols.length == 0) {
            return;
        }
        symbols.forEach((symbol) => {
            this.symbolMap.set(`${symbol.base}_${symbol.quote}`, Object.assign(Object.assign({}, symbol), TradeUtils_1.TradeUtils.parseDisplay(symbol.base, symbol.quote, this.apiKey.market, this.tradeExchangeInfo.futureTag)));
        });
        this.symbols = symbols;
    }
    getDefaultSymbols() {
        let defaults = this.defaultSymbols;
        return this.symbols || defaults || [];
    }
    getSymbol(base, quote) {
        const key = `${base}_${quote}`;
        if (this.symbolMap.has(key)) {
            return this.symbolMap.get(key);
        }
        return undefined;
    }
    /**
     * 判断是否支持策略订单类型
     * @returns {boolean}
     * @param orderType
     */
    checkMarketSupportOrderType(orderType) {
        if (this.tradeExchangeInfo) {
            return (this.tradeExchangeInfo.support.findIndex((value) => {
                return value === orderType;
            }) >= 0);
        }
    }
    /**
     * 创建订单过滤observable
     * @param {ExchangeOrderRequest} orderRequest
     * @returns {Observable<boolean>}
     * @private
     */
    createFilterObservable(orderRequest) {
        return (0, rxjs_1.of)(orderRequest)
            .pipe((0, operators_1.switchMap)((orderRequest) => {
            let base = "";
            let quote = "";
            if (orderRequest.customParam) {
                base = orderRequest.customParam.base;
                quote = orderRequest.customParam.quote;
            }
            else if (orderRequest.stopLimitParam) {
                base = orderRequest.stopLimitParam.customParam.base;
                quote = orderRequest.stopLimitParam.customParam.quote;
            }
            else if (orderRequest.gridParam) {
                base = orderRequest.gridParam.base;
                quote = orderRequest.gridParam.quote;
            }
            else if (orderRequest.trailingStopLimitParam) {
                base = orderRequest.trailingStopLimitParam.base;
                quote = orderRequest.trailingStopLimitParam.quote;
            }
            else if (orderRequest.marketParam) {
                base = orderRequest.marketParam.base;
                quote = orderRequest.marketParam.quote;
            }
            if (orderRequest.symbolInfo) {
                return (0, rxjs_1.of)(orderRequest.symbolInfo);
            }
            else {
                return this._getSymbolPrecisionData(base, quote);
            }
        }))
            .pipe((0, operators_1.map)((exchangeSymbol) => {
            let amount = 0;
            let price = 0;
            if (orderRequest.customParam) {
                amount = Number(orderRequest.customParam.amount);
                price = Number(orderRequest.customParam.price);
            }
            else if (orderRequest.marketParam) {
                if (orderRequest.marketParam.side === "buy") {
                    //市价买单,花费spending的quote买不确定数量的base
                    amount = 1e9;
                    price = Number(orderRequest.marketParam.spending || 0);
                }
                else {
                    //市价卖单,卖amount个base换不确定数量的quote
                    amount = Number(orderRequest.marketParam.amount || 0);
                    price = 1e9;
                }
            }
            else if (orderRequest.stopLimitParam) {
                amount = parseFloat(orderRequest.stopLimitParam.customParam.amount + "");
                price = parseFloat(orderRequest.stopLimitParam.limit);
            }
            else if (orderRequest.gridParam) {
                amount = parseFloat(orderRequest.gridParam.amount);
                price = parseFloat(orderRequest.gridParam.low);
            }
            else if (orderRequest.gridProParam) {
                amount = 1e9;
                price = parseFloat(orderRequest.gridProParam.bottom);
            }
            else if (orderRequest.trailingStopLimitParam) {
                amount = parseFloat(orderRequest.trailingStopLimitParam.amount);
                if (orderRequest.trailingStopLimitParam.buy === "0") {
                    let maxPrice = Math.max(parseFloat(orderRequest.trailingStopLimitParam.trigger), parseFloat(orderRequest.trailingStopLimitParam.tickerPrice));
                    price = maxPrice * (1 - parseFloat(orderRequest.trailingStopLimitParam.trailing_percentage));
                }
                else {
                    price = parseFloat(orderRequest.trailingStopLimitParam.buy);
                }
            }
            if (exchangeSymbol && exchangeSymbol.limit) {
                if (exchangeSymbol.limit.amount !== undefined &&
                    !isNaN(exchangeSymbol.limit.amount.min) &&
                    amount < exchangeSymbol.limit.amount.min) {
                    throw {
                        response: {
                            code: TradeTypeDef_1.CreateOrderFailedReason.lowAmount,
                            reason: "create failed low amount",
                            msg: `${exchangeSymbol.limit.amount.min}`,
                        },
                    };
                }
                if (exchangeSymbol.limit.price !== undefined &&
                    !isNaN(exchangeSymbol.limit.price.min) &&
                    price < exchangeSymbol.limit.price.min) {
                    throw {
                        response: {
                            code: TradeTypeDef_1.CreateOrderFailedReason.lowPrice,
                            reason: "create failed low price",
                            msg: `${exchangeSymbol.limit.price.min}`,
                        },
                    };
                }
                ///> 市价单可能传入0，不检查
                if (price > 0) {
                    if (exchangeSymbol.limit.cost !== undefined &&
                        !isNaN(exchangeSymbol.limit.cost.min) &&
                        amount * price < exchangeSymbol.limit.cost.min) {
                        throw {
                            response: {
                                code: TradeTypeDef_1.CreateOrderFailedReason.lowQuoteAmount,
                                reason: "create failed low quote amount",
                                msg: `${exchangeSymbol.limit.cost.min}`,
                            },
                        };
                    }
                    else {
                        if (this.apiKey.market.toLowerCase() === "bittrex" && exchangeSymbol.quote.toUpperCase() === "BTC") {
                            if (amount * price <= 0.0005) {
                                throw {
                                    response: {
                                        code: TradeTypeDef_1.CreateOrderFailedReason.lowQuoteAmount,
                                        reason: "create failed low quote amount",
                                        msg: "0.0005",
                                    },
                                };
                            }
                        }
                        else if (exchangeSymbol.priceUnit && exchangeSymbol.priceUnit > 0) {
                            ///> fix price unit
                            if (!new trade_utils_lib_1.SafeDecimal(price).mod(new trade_utils_lib_1.SafeDecimal(exchangeSymbol.priceUnit)).equals(0)) {
                                throw {
                                    response: {
                                        code: TradeTypeDef_1.CreateOrderFailedReason.priceInvalid,
                                        reason: "create failed price invalid",
                                        msg: `${exchangeSymbol.priceUnit}`,
                                    },
                                };
                            }
                        }
                    }
                }
            }
            return true;
        }));
    }
    /**
     * 获取交易对精度信息
     * @returns {Observable<ExchangeSymbol>}
     */
    _getSymbolPrecisionData(base, quote) {
        if (this.apiKey.market === "huobi.pro") {
            return this.getRefreshTradingLimitInfoObservable(base, quote);
        }
        return (0, rxjs_1.of)(0)
            .pipe((0, operators_1.switchMap)(() => {
            let defaultSymbols = this.getDefaultSymbols();
            if (defaultSymbols.length === 0) {
                return this.getExchangeSymbols().pipe((0, operators_1.switchMap)((symbolList) => {
                    return (0, rxjs_1.from)(symbolList);
                }));
            }
            else {
                return (0, rxjs_1.from)(defaultSymbols);
            }
        }))
            .pipe((0, operators_1.filter)((value) => {
            return value.base.toUpperCase() === base.toUpperCase() && value.quote.toUpperCase() === quote.toUpperCase();
        }))
            .pipe((0, operators_1.take)(1))
            .pipe((0, operators_1.defaultIfEmpty)(undefined))
            .pipe((0, operators_1.switchMap)((symbolInfo) => {
            if (symbolInfo === undefined) {
                return (0, rxjs_1.of)(undefined);
            }
            return (0, rxjs_1.of)(symbolInfo);
        }));
    }
    askTradePermission() {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.flatMap)((token) => {
            if (!token) {
                return (0, rxjs_1.of)(false);
            }
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/ask_trade_permission`, this.extraParamRuntime["commonParam"]), {
                Authorization: token.toString(),
                "Content-Type": "application/json;charset=UTF-8",
            }, { use: "grid" }, (response) => {
                return response.code;
            })
                .pipe((0, operators_1.map)((status) => {
                return status === 0;
            }))
                .pipe((0, operators_1.catchError)((err) => {
                return (0, rxjs_1.of)(false);
            }));
        }));
    }
    /**
     * 获取交易所最小成交量
     * @param symbol
     * @param tickerPrice
     * @returns {*}
     */
    _getValidMinAmount(symbol, tickerPrice) {
        let result = new decimal_js_1.Decimal(0);
        if (symbol) {
            let decimal = 6;
            if (symbol.amount_decimal !== undefined) {
                decimal = symbol.amount_decimal;
            }
            else if (symbol.amount !== undefined) {
                decimal = symbol.amount;
            }
            if (symbol.limit) {
                try {
                    if (symbol.limit.amount && symbol.limit.amount.min) {
                        result = new decimal_js_1.Decimal(symbol.limit.amount.min);
                    }
                    if (symbol.limit.cost && symbol.limit.cost.min) {
                        let costMin = new decimal_js_1.Decimal(symbol.limit.cost.min);
                        let minAmount = costMin.div(tickerPrice);
                        if (minAmount.greaterThan(result)) {
                            result = minAmount.mul(1.01);
                        }
                    }
                }
                catch (e) { }
            }
            return trade_utils_lib_1.NumberCommonUtils.effectiveDecimal(result, decimal, decimal_js_1.Decimal.ROUND_UP);
        }
        return result.toString();
    }
    /**
     * 请求策略的评分信息
     */
    requestStrategyScores() {
        return (0, rxjs_1.of)(0)
            .pipe((0, operators_1.flatMap)(() => {
            let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/statistic/bots`;
            url = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(url, this.extraParamRuntime["commonParam"]);
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(url, null, (resp) => {
                return resp;
            });
        }))
            .pipe((0, operators_1.map)((resp) => {
            if (resp) {
                const result = resp;
                if (result && result.data) {
                    return result.data;
                }
                throw `result formatter error:${resp}`;
            }
            throw "can not get data";
        }));
    }
    /**
     * 网格2.0获取bu_order_id对应的订单的借贷记录
     */
    requestLoanRecords(bu_order_id, page = 1, page_size = 20) {
        return trade_utils_lib_1.ObservableUtils.get(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/${bu_order_id}/loan_records`, { page_size, page }, {}, true);
    }
    /**
     * 请求永续合约交易所手续费
     */
    requestSwapFee() {
        return (0, trade_token_lib_1.acquireKeyResolver)()
            .requestSigner.getSignRequest("POST", "/futures/get_swap_fee", JSON.stringify({ exchange: this.apiKey.market }))
            .pipe((0, operators_1.map)((data) => {
            return data;
        }), (0, operators_1.map)((res) => {
            if (res && res.data) {
                return res.data;
            }
            throw res;
        }));
    }
    /**
     * 请求币安合约交易配置文件
     */
    requestBinanceLeverageConfigures(exchange) {
        const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().CONFIG_HOST;
        if (!host) {
            return (0, rxjs_1.of)(0).pipe((0, operators_1.map)(() => {
                throw "can not fetch CONFIG_HOST";
            }));
        }
        const url = `${host}/leverage_configs.json`;
        return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(url, { "Cache-Control": "max-age=0" }, (res) => {
            return res;
        }).pipe((0, operators_1.map)((res) => {
            return res[exchange];
        }));
    }
    /**
     * 请求网格2.0的多空比
     */
    requestGridProPairsBearishRatio(base, quote) {
        return (0, rxjs_1.of)(0).pipe((0, operators_1.flatMap)(() => {
            const pair = base.toLowerCase() + "_" + quote.toLowerCase();
            let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/grid_pro/bearish_ratio?pair=${pair}`;
            url = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(url, this.extraParamRuntime["commonParam"]);
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(url, null, (resp) => {
                return resp;
            });
        }));
    }
    /**
     * check用户网格2.0启动条件
     * @param request
     */
    checkGridOrderCanCreate(request) {
        // 参数不支持空串
        const params = {
            bu_order_type: request.bu_order_type,
            base: request.symbol.base,
            quote: request.symbol.quote,
            exchange: request.market,
            base_total_investment: request.base_total_investment || null,
            quote_total_investment: request.quote_total_investment || null,
            top: request.top,
            bottom: request.bottom,
            row: request.row,
            earn_coin: request.earn_coin,
            trend: request.trend,
            grid_type: request.grid_type,
            loss_stop: request.loss_stop || null,
            profit_stop: request.profit_stop || null,
            precision: {
                amount: request.symbol.amount,
                price: request.symbol.precision,
            },
            limits: request.symbol.limit,
            leverage: request.leverage || null,
            per_volume: request.per_volume || null,
            open_price: request.open_price || null,
            condition: request.condition || null,
            condition_direction: request.condition_direction || null,
            fee_rate: request.fee_rate || null,
        };
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/grid_pro/verify_order`;
        return trade_utils_lib_1.ObservableUtils.post(url, JSON.stringify(params), null);
    }
    /**
     * check用户网格启动条件
     * @param bodyParam
     */
    checkGridRequireBalance(bodyParam) {
        return (0, rxjs_1.of)(0)
            .pipe((0, operators_1.flatMap)(() => {
            if (!this.symbols) {
                return this.getExchangeSymbols().pipe((0, operators_1.map)(() => {
                    return true;
                }));
            }
            else {
                return (0, rxjs_1.of)(true);
            }
        }))
            .pipe((0, operators_1.flatMap)(() => {
            let symbols = this.getDefaultSymbols().filter((symbol) => {
                return (symbol.base.toUpperCase() === bodyParam.base.toUpperCase() &&
                    symbol.quote.toUpperCase() === bodyParam.quote.toUpperCase());
            });
            if (symbols.length > 0) {
                bodyParam.precision = {
                    amount: symbols[0].amount,
                    price: symbols[0].precision,
                };
                bodyParam["limits"] = symbols[0].limit;
                if (bodyParam["volume_reset"] === 1 && !bodyParam["per_volume"] && bodyParam["check_price"]) {
                    bodyParam["per_volume"] = this._getValidMinAmount(symbols[0], bodyParam["check_price"]);
                }
                const priceUnit = symbols[0].priceUnit;
                if (priceUnit !== undefined) {
                    bodyParam["units"] = {
                        price_unit: priceUnit,
                    };
                }
            }
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/check_grid_balance_enough`, this.extraParamRuntime["commonParam"]), null, JSON.stringify(bodyParam), (response) => {
                return response;
            });
        }))
            .pipe((0, operators_1.map)((result) => {
            if (result.code === 0) {
                return {
                    enough: true,
                    errMsg: "",
                    needBase: result.data.need_base,
                    needQuote: result.data.need_quote,
                    realNeedBase: result.data.real_need_base,
                    realNeedQuote: result.data.real_need_quote,
                };
            }
            else {
                return {
                    enough: false,
                    errMsg: "",
                    needBase: 0,
                    needQuote: 0,
                    realNeedBase: 0,
                    realNeedQuote: 0,
                };
            }
        }))
            .pipe((0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)({
                enough: false,
                errMsg: err.message,
                needBase: err.data.need_base,
                needQuote: err.data.need_quote,
                realNeedBase: err.data.real_need_base,
                realNeedQuote: err.data.real_need_quote,
            });
        }));
    }
    checkIGBalanceEnough(bodyParam) {
        return (0, rxjs_1.of)(0)
            .pipe((0, operators_1.flatMap)(() => {
            if (!this.symbols) {
                return this.getExchangeSymbols().pipe((0, operators_1.map)(() => {
                    return true;
                }));
            }
            else {
                return (0, rxjs_1.of)(true);
            }
        }))
            .pipe((0, operators_1.flatMap)(() => {
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/check_strategy_ig_balance_enough_v2`, this.extraParamRuntime["commonParam"]), null, JSON.stringify(bodyParam), (response) => {
                return response;
            });
        }))
            .pipe((0, operators_1.map)((result) => {
            if (result.code === 0) {
                return result.data;
            }
            else {
                const data = {
                    code: "FAILED",
                    base_allocate: 0,
                    quote_allocate: 0,
                    invest: 0,
                    invest_allocate: 0,
                    price: 0,
                    ask1: 0,
                    bid1: 0,
                    errMsg: `${result}`,
                };
                return data;
            }
        }))
            .pipe((0, operators_1.catchError)((err) => {
            if (err.data) {
                const data = err.data;
                if (data) {
                    return (0, rxjs_1.of)(data);
                }
            }
            const data = {
                code: err.code,
                base_allocate: 0,
                quote_allocate: 0,
                invest: 0,
                invest_allocate: 0,
                price: 0,
                ask1: 0,
                bid1: 0,
                errMsg: err.message,
            };
            return (0, rxjs_1.of)(data);
        }));
    }
    /**
     * 拷贝策略
     * @param botId
     */
    copyTradingBot(botId) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.flatMap)((token) => {
            if (!token) {
                return (0, rxjs_1.of)({});
            }
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/pool/copy_bot`, this.extraParamRuntime["commonParam"]), {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            }, {
                bot_id: botId,
            }, (response) => {
                return response;
            });
        }));
    }
    _getBalanceCurrency(coins, url) {
        let queryTokens = coins.map((coin) => {
            return {
                base: coin.toUpperCase(),
                quote: "USD",
                market: this.apiKey.market,
            };
        });
        let queryMBQ = { mbq: queryTokens };
        return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(url, this.extraParamRuntime["commonParam"]), undefined, queryMBQ ? JSON.stringify(queryMBQ) : null, (resp) => {
            return resp;
        });
    }
    _getBalanceCurrencyRequestObservable(coins, url) {
        return (0, rxjs_1.of)(0)
            .pipe((0, operators_1.flatMap)(() => {
            return (0, rxjs_1.interval)(5000);
        }))
            .pipe((0, operators_1.startWith)(0))
            .pipe((0, operators_1.exhaustMap)(() => {
            return this._getBalanceCurrency(coins, url);
        }))
            .pipe((0, operators_1.retryWhen)(() => {
            return (0, rxjs_1.of)(0).pipe((0, operators_1.delay)(2000));
        }));
    }
    /**
     * 获取币对应的发币价格，从buserver获取
     * @param {Array<string>} coins
     * @param {string} url
     * @returns {Observable<any>}
     */
    getBalanceCurrencyPrice(coins, url) {
        return this._getBalanceCurrencyRequestObservable(coins, url);
    }
    getOrderBookDataFromBUServerObservable(base, quote) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().webSocketHost}/stream`;
        const data = {
            action: "subscribe",
            channel: ExchangeWebSocket_1.DataType.orderBook,
            data: [
                {
                    exchange: this.apiKey.market,
                    base: base,
                    quote: quote,
                },
            ],
        };
        return (0, BaseWebSocket_1.getWebSocketObservable)(url, data).pipe((0, operators_1.map)((data) => {
            return this._parseDepth(base, quote, data.data);
        }));
    }
    _parseDepth(base, quote, data) {
        if (data.length <= 0) {
            throw "current exchange pair not supported";
        }
        const bids = [];
        const asks = [];
        let jsonEntry = data[0];
        if (jsonEntry.bids && jsonEntry.bids.length) {
            jsonEntry.bids.forEach((item) => {
                const entry = {
                    price: parseFloat(item[0]),
                    quantity: parseFloat(item[1]),
                };
                bids.push(entry);
            });
        }
        if (jsonEntry.asks && jsonEntry.asks.length) {
            jsonEntry.asks.forEach((item) => {
                const entry = {
                    price: parseFloat(item[0]),
                    quantity: parseFloat(item[1]),
                };
                asks.push(entry);
            });
        }
        return {
            base: base,
            quote: quote,
            bids: bids,
            asks: asks,
        };
    }
    getQueryGridBasicInfoObservable(griOrderId, orderType) {
        return undefined;
    }
    /**
     * 获取ticker价格用来计算利润等数据
     * 先访问我们自己的服务器，快，如果失败了就利用ccxt获取
     * @param base
     * @param quote
     */
    querySymbolTickerPrice(base, quote, market) {
        if (this.extraParamRuntime && "tickerHost" in this.extraParamRuntime) {
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${this.extraParamRuntime["tickerHost"]}/get_tickers_index`, this.extraParamRuntime["commonParam"]), undefined, JSON.stringify({
                mbq: [
                    {
                        base: base.toUpperCase(),
                        quote: quote.toUpperCase(),
                        market: market !== null && market !== void 0 ? market : this.apiKey.market,
                    },
                ],
            }), (response) => {
                return response;
            }).pipe((0, operators_1.flatMap)((result) => {
                if (result && result.data && result.data.length > 0) {
                    return (0, rxjs_1.of)({
                        latest: result.data[0].price,
                        fiat: result.data[0].fiat,
                        symbol: `${base}/${quote}`,
                        base: base,
                        quote: quote,
                        latestAmount: 0,
                        prev24HPrice: 0,
                        high: result.data[0].high,
                        low: result.data[0].low,
                        baseVol: result.data[0].volume,
                        quoteVol: result.data[0].volume_to,
                        changePercent: result.data[0].change_percent,
                        fullName: result.data[0].full_name,
                    });
                }
                else {
                    return (0, rxjs_1.of)(null);
                }
            }));
        }
    }
    queryTickerByRest(base, quote, market) {
        return this.querySymbolTickerPrice(base, quote, market);
    }
    queryTickerWithSymbolList(symbolList) {
        return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${this.extraParamRuntime["tickerHost"]}/get_tickers_index`, this.extraParamRuntime["commonParam"]), undefined, JSON.stringify({
            mbq: symbolList,
        }), (response) => {
            return response.data;
        })
            .pipe((0, operators_1.map)((result) => {
            return result.map((tickerItem) => {
                return {
                    base: tickerItem.base,
                    quote: tickerItem.quote,
                    latest: tickerItem.price,
                    fiat: tickerItem.fiat,
                    priceChange: tickerItem.change_percent,
                    fullName: tickerItem.full_name,
                    market: tickerItem.market,
                    exchange: tickerItem.market,
                    BTCValue: tickerItem.BTCValue,
                    ETHValue: tickerItem.ETHValue,
                    volume: tickerItem.volume,
                    volume_to: tickerItem.volume_to,
                    high: tickerItem.high,
                    low: tickerItem.low,
                };
            });
        }))
            .pipe((0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)([]);
        }));
    }
    getTickerListByBUServerObservable(symbolList) {
        return (0, trade_utils_lib_1.requestWithRetry)(() => {
            return (0, webSocket_1.webSocket)({
                url: `${this.extraParamRuntime["tickerSocket"]}/ws/ticker`,
                openObserver: {
                    next: (value) => {
                        console.log("open ticker websocket success");
                    },
                },
                closeObserver: {
                    next: (value) => {
                        console.log("close ticker websocket success");
                    },
                },
                deserializer: (e) => {
                    if (e.data) {
                        try {
                            return JSON.parse(e.data);
                        }
                        catch (e) {
                            console.error(e);
                        }
                    }
                    return undefined;
                },
            })
                .multiplex(() => {
                return {
                    mbq: symbolList.map((symbolInfo) => {
                        var _a;
                        return {
                            base: symbolInfo.base.toUpperCase(),
                            quote: symbolInfo.quote.toUpperCase(),
                            market: (_a = symbolInfo.market) !== null && _a !== void 0 ? _a : this.apiKey.market,
                        };
                    }),
                };
            }, () => {
                return {
                    code: 4000,
                    msg: "websocket disappear",
                };
            }, () => {
                return true;
            })
                .pipe((0, operators_1.flatMap)((result) => {
                if (result && result.data) {
                    return (0, rxjs_1.of)(result.data.map((tickerInfo) => ({
                        symbol: `${tickerInfo.base.toUpperCase()}/${tickerInfo.quote.toUpperCase()}`,
                        base: tickerInfo.base,
                        quote: tickerInfo.quote,
                        latest: tickerInfo.price,
                        fiat: tickerInfo.fiat,
                        exchange: tickerInfo.market,
                        latestAmount: undefined,
                        changePercent: tickerInfo.change_percent,
                        prev24HPrice: tickerInfo.price - tickerInfo.change_percent * tickerInfo.price,
                        high: tickerInfo.high,
                        low: tickerInfo.low,
                        baseVol: tickerInfo.volume,
                        quoteVol: tickerInfo.volume_to,
                        fullName: tickerInfo.full_name,
                    })));
                }
                else {
                    return rxjs_1.EMPTY;
                }
            }));
        });
    }
    getMarketWSTickerObservable(market, symbolList) {
        if (market) {
            let wsConfig = {
                url: `${this.extraParamRuntime["tickerSocket"]}/ws/ticker/market`,
                openObserver: {
                    next: (event) => {
                        const ws = event.target;
                        ws.send(JSON.stringify({
                            market: market,
                        }));
                    },
                },
                closeObserver: {
                    next: (event) => { },
                },
            };
            return (0, webSocket_1.webSocket)(wsConfig).pipe((0, operators_1.map)((data) => {
                return data.data.map((tickerInfo) => ({
                    symbol: `${tickerInfo.base.toUpperCase()}/${tickerInfo.quote.toUpperCase()}`,
                    base: tickerInfo.base,
                    quote: tickerInfo.quote,
                    latest: tickerInfo.price,
                    fiat: tickerInfo.fiat,
                    latestAmount: undefined,
                    changePercent: tickerInfo.change_percent,
                    prev24HPrice: tickerInfo.price - tickerInfo.change_percent * tickerInfo.price,
                    high: tickerInfo.high,
                    low: tickerInfo.low,
                    baseVol: tickerInfo.volume,
                    quoteVol: tickerInfo.volume_to,
                    fullName: tickerInfo.full_name,
                }));
            }));
        }
        else if (symbolList) {
            return this.getTickerListByBUServerObservable(symbolList);
        }
    }
    getTickerByBUServerObservable(base, quote) {
        return this.getTickerListByBUServerObservable([{ base: base, quote: quote }])
            .pipe((0, operators_1.filter)((data) => data && data.length > 0))
            .pipe((0, operators_1.map)((data) => {
            return data[0];
        }));
    }
    /**
     * 获取交易对价格，返回可持续观察的Subject
     * @param {string} base
     * @param {string} quote
     * @returns {Observable<ExchangeTicker>}
     */
    getTicker(base, quote) {
        let getTicketWebSocketSubject = this.getTickerByBUServerObservable(base, quote);
        let getTickerRestApiApiObservable = this.querySymbolTickerPrice(base, quote)
            .pipe((0, operators_1.catchError)((error) => {
            console.log(error);
            return (0, rxjs_1.of)(undefined);
        }))
            .pipe((0, operators_1.filter)((result) => {
            return !!result;
        }));
        return (0, rxjs_1.merge)(getTickerRestApiApiObservable, getTicketWebSocketSubject)
            .pipe((0, operators_1.map)((result) => {
            if (result === null || result.latest === 0) {
                throw "not support";
            }
            return result;
        }))
            .pipe((0, operators_1.catchError)((err) => {
            if (err === "not support") {
                return this.getTickerImpl(base, quote).pipe((0, operators_1.switchMap)((ticker) => {
                    return this.querySymbolTickerPrice(base, quote)
                        .pipe((0, operators_1.debounceTime)(1000))
                        .pipe((0, operators_1.map)((priceInfo) => {
                        ticker.fiat = priceInfo.fiat;
                        return ticker;
                    }));
                }));
            }
            else {
                throw "getTicker went wrong!";
            }
        }));
    }
    getQueryCustomOrderObservable(base, quote, queryOpenOnly, orderId, limit, isManual) {
        return (0, rxjs_1.of)(0)
            .pipe((0, operators_1.flatMap)(() => {
            return (0, rxjs_1.interval)(5000);
        }))
            .pipe((0, operators_1.startWith)(0))
            .pipe((0, operators_1.switchMap)(() => {
            return this._convertOrderObservable(base, quote, queryOpenOnly, orderId, limit, isManual);
        }))
            .pipe((0, operators_1.retryWhen)(() => {
            return (0, rxjs_1.of)(0).pipe((0, operators_1.delay)(5000));
        }));
    }
    /**
     *
     * @param base
     * @param quote
     * @param queryOpenOnly
     * @param orderId
     * @param limit
     * @param isManual //过滤策略产生的挂单
     * @param includeStrategy // 2020.12.25 新版本接口 过滤策略产生的挂单
     */
    _convertOrderObservable(base, quote, queryOpenOnly, orderId, limit, isManual, includeStrategy) {
        let result = undefined;
        if (queryOpenOnly) {
            result = this.queryCustomOpenOrdersRestApi(base, quote, orderId, limit, isManual, includeStrategy);
        }
        else {
            result = this.queryCustomClosedOrdersRestApi(base, quote, orderId, limit, "PREV", isManual, includeStrategy);
        }
        return result.pipe((0, operators_1.map)((data) => {
            return data
                .filter((obj) => obj.type === TradeTypeDef_1.ExchangeOrderType.limit || obj.type === TradeTypeDef_1.ExchangeOrderType.market)
                .map((order) => {
                let arr = order.symbol.split("/");
                const symbolInfo = this.symbolMap.get(`${arr[0]}_${arr[1]}`);
                return TradeUtils_1.TradeUtils.convertToExchangeOrder(order, symbolInfo);
            });
        }));
    }
    /**
     * 查询交易所订单
     * @param base
     * @param quote
     * @param queryOpen  查询委托单还是已完成订单
     * @param orderId
     * @param limit
     * @param isManual
     */
    queryCustomOrders(base, quote, queryOpen, orderId, limit, isManual) {
        if (queryOpen) {
            return this.getQueryCustomOrderObservable(base, quote, queryOpen, orderId, limit, isManual);
        }
        return this.getQueryCustomOrderObservable(base, quote, queryOpen, orderId, limit, isManual).pipe((0, operators_1.switchMap)((customOrderList) => {
            if (customOrderList && customOrderList.length > 0) {
                return this.querySymbolTickerPrice(base, quote).pipe((0, operators_1.map)((priceInfo) => {
                    customOrderList.forEach((item) => {
                        item.exchangeCustomOrder.priceChange =
                            (priceInfo.latest - item.exchangeCustomOrder.avgDealPrice) / item.exchangeCustomOrder.avgDealPrice;
                    });
                    return customOrderList;
                }));
            }
            return (0, rxjs_1.of)(customOrderList);
        }));
    }
    /**
     * 分页查询交易所订单 目前分页只支持pionex
     * @param queryParam
     * pionex:
     * 可以不传base quote,默认取所有交易对的
     * 首次orderId不传,下次以orderId为第一条,取之后的limit个数量
     * limit 最小1最大1000,默认为500
     *
     * 其他交易所:
     * base quote必须要传
     * limit暂时不生效
     * @param queryOpen 要正在运行的还是已关闭的订单
     * @param repeat 是否是重复请求
     */
    queryCustomOrderPage(queryParam, queryOpen, repeat) {
        if (repeat) {
            return (0, rxjs_1.of)(0)
                .pipe((0, operators_1.flatMap)(() => {
                return (0, rxjs_1.interval)(8000);
            }))
                .pipe((0, operators_1.startWith)(0))
                .pipe((0, operators_1.exhaustMap)(() => {
                return this._convertOrderObservable(queryParam.base, queryParam.quote, queryOpen, queryParam.orderId, queryParam.limit, queryParam.is_manual, queryParam.includeStrategy);
            }))
                .pipe((0, operators_1.retryWhen)(() => {
                return (0, rxjs_1.of)(0).pipe((0, operators_1.delay)(5000));
            }));
        }
        return this._convertOrderObservable(queryParam.base, queryParam.quote, queryOpen, queryParam.orderId, queryParam.limit, queryParam.is_manual, queryParam.includeStrategy);
    }
    pauseWebSocket() { }
    stopRefreshGridDetailInfo() { }
    /**
     * 查询该用户是否存在策略交易的权限
     */
    queryTradePermission() {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.flatMap)((token) => {
            if (!token) {
                return (0, rxjs_1.of)(false);
            }
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/query_trade_permission`, this.extraParamRuntime["commonParam"]), {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            }, { use: "grid" }, (response) => {
                return response.code;
            })
                .pipe((0, operators_1.map)((status) => {
                return status === 0;
            }))
                .pipe((0, operators_1.catchError)((err) => {
                return (0, rxjs_1.of)(false);
            }));
        }));
    }
    refreshSubmittedOrderRightNow() {
        if (this.refreshRightNow) {
            this.refreshRightNow.next(true);
        }
    }
    /**
     * 请求策略广场数据
     * @param orderType
     * @param exchange
     * @param base
     * @param quote
     */
    requestBotPoolData(orderType, exchange, base, quote) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/pool/bots?bu_order_type=${orderType}`;
        if (exchange) {
            url = url + `&exchange=${exchange}`;
        }
        else if (base) {
            url = url + `&base=${base}`;
        }
        else if (quote) {
            url = url + `&quote=${quote}`;
        }
        return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(url, this.extraParamRuntime["commonParam"]), null, (response) => {
            return response;
        });
    }
    requestGridProfitData(type) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.flatMap)((token) => {
            if (!token) {
                return (0, rxjs_1.of)({
                    total_profit: 0,
                    total_currencies: [],
                    profit_data: [],
                });
            }
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/grid_profits?type=${type}`, this.extraParamRuntime["commonParam"]), {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            }, (response) => {
                return response.data;
            });
        }));
    }
    /**
     * 请求我的策略
     */
    requestMyBotData(orderType, exchange, base, quote) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.flatMap)((token) => {
            if (!token) {
                return (0, rxjs_1.of)({
                    data: [],
                });
            }
            let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/pool/my_bots?bu_order_type=${orderType}`;
            if (exchange) {
                url = url + `&exchange=${exchange}`;
            }
            else if (base) {
                url = url + `&base=${base}`;
            }
            else if (quote) {
                url = url + `&quote=${quote}`;
            }
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(url, this.extraParamRuntime["commonParam"]), {
                Authorization: token,
            }, (response) => {
                return response;
            });
        }));
    }
    unInitialized() {
        this.pauseWebSocket();
    }
    resolvePermissionResult(market, err) {
        const errorDetail = err.message || `${err}`;
        if (errorDetail.indexOf("ccxt.InvalidOrder") > 0 ||
            errorDetail.indexOf("invalid-amount") > 0 ||
            errorDetail.indexOf("Invalid quantity") > 0 ||
            errorDetail.indexOf("Invalid price") > 0 ||
            errorDetail.indexOf("Quantity too low") > 0 ||
            errorDetail.indexOf("无效的数量") > 0 ||
            errorDetail.indexOf("QUANTITY_NOT_PROVIDED") > 0) {
            return (0, rxjs_1.of)(true);
        }
        switch (market) {
            case ExchangeID_1.ExchangeID.BIBOX: {
                const errObj = JSON.parse(err.message.replace("bibox", ""));
                if (errObj && errObj.error.code == 3000) {
                    return (0, rxjs_1.of)(true);
                }
                break;
            }
            case ExchangeID_1.ExchangeID.BITZ: {
                if ((err + "").indexOf("Price entry error") > 0) {
                    return (0, rxjs_1.of)(true);
                }
                break;
            }
            case ExchangeID_1.ExchangeID.COINPARK: {
                const errObj = JSON.parse(err.message.replace("coinpark", ""));
                if (errObj && errObj.error.code == 3000) {
                    return (0, rxjs_1.of)(true);
                }
                break;
            }
            case ExchangeID_1.ExchangeID.GATE_IO: {
                const errObj = JSON.parse(err.message.replace("gateio", ""));
                if (errObj && errObj.code == 12) {
                    return (0, rxjs_1.of)(true);
                }
                break;
            }
        }
        throw err;
    }
    ///>
    takeProfit(bu_order_id) {
        throw new Error("not implemented");
    }
    /**
     * 获取单网格买入数量
     * @param bodyParam
     */
    requireGridPervolume(bodyParam) {
        return (0, rxjs_1.of)(0)
            .pipe((0, operators_1.flatMap)(() => {
            if (!this.symbols) {
                return this.getExchangeSymbols().pipe((0, operators_1.map)(() => {
                    return true;
                }));
            }
            else {
                return (0, rxjs_1.of)(true);
            }
        }))
            .pipe((0, operators_1.flatMap)(() => {
            let symbols = this.getDefaultSymbols().filter((symbol) => {
                return (symbol.base.toUpperCase() === bodyParam.base.toUpperCase() &&
                    symbol.quote.toUpperCase() === bodyParam.quote.toUpperCase());
            });
            if (symbols.length > 0) {
                bodyParam.precision = {
                    amount: symbols[0].amount,
                    price: symbols[0].precision,
                };
                bodyParam["limits"] = symbols[0].limit;
            }
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/get_per_vol_by_use_percent`, this.extraParamRuntime["commonParam"]), null, JSON.stringify(bodyParam), (response) => {
                return response;
            });
        }))
            .pipe((0, operators_1.map)((result) => {
            if (result.code === 0) {
                return result.data.per_volume;
            }
            else {
                return -1;
            }
        }))
            .pipe((0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)(-1);
        }));
    }
    requireTopGridAIStrategy(market) {
        return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/ai/most_volume`, this.extraParamRuntime["commonParam"]), {
            "Content-Type": "application/json;charset=UTF-8",
        }, {
            exchange: market,
        }, (response) => {
            return response;
        })
            .pipe((0, operators_1.map)((result) => {
            if (result.code === 0) {
                return result.data.map((item) => {
                    return {
                        base: item.base,
                        quote: item.quote,
                        picked: item.picked,
                        annualized: item.annualized,
                        volatility: item.volatility ? item.volatility : 0,
                    };
                });
            }
            else {
                return [];
            }
        }))
            .pipe((0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)([]);
        }));
    }
    requireTopGridAIStrategyBatch(marketList) {
        return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/ai/batch_most_volume`, this.extraParamRuntime["commonParam"]), {
            "Content-Type": "application/json;charset=UTF-8",
        }, {
            exchange: marketList.join(","),
        }, (response) => {
            return response;
        })
            .pipe((0, operators_1.map)((result) => {
            if (result.code === 0) {
                return result.data.map((item) => {
                    return {
                        market: item.exchange,
                        base: item.base,
                        quote: item.quote,
                        picked: item.picked,
                        annualized: item.annualized,
                        volatility: item.volatility ? item.volatility : 0,
                    };
                });
            }
            else {
                return [];
            }
        }))
            .pipe((0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)([]);
        }));
    }
    requireIGAIStrategy(market, base, quote) {
        return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/ai/unlimited_strategy`, this.extraParamRuntime["commonParam"]), {
            "Content-Type": "application/json",
        }, {
            exchange: market,
            base: base,
            quote: quote,
        }, (response) => {
            return response;
        }).pipe((0, operators_1.map)((result) => {
            if (result.code === 0 && result.data) {
                const data = result.data;
                if (data) {
                    return data;
                }
            }
            throw result;
        }));
    }
    requireAIStrategyWithSymbol(market, base, quote) {
        return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/ai/strategy`, this.extraParamRuntime["commonParam"]), {
            "Content-Type": "application/json;charset=UTF-8",
        }, {
            exchange: market,
            base: base,
            quote: quote,
        }, (response) => {
            return response;
        })
            .pipe((0, operators_1.map)((result) => {
            var _a;
            if (result.code === 0 && "high" in result.data) {
                return {
                    market: market,
                    base: base,
                    quote: quote,
                    annualized: result.data.annualized,
                    high: result.data.high,
                    low: result.data.low,
                    grid_count: result.data.grid_count,
                    strategy_id: result.data.strategy_id,
                    max_draw_down: result.data.max_draw_down,
                    options: (_a = result.data.options) !== null && _a !== void 0 ? _a : [],
                };
            }
            else {
                return undefined;
            }
        }))
            .pipe((0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)(undefined);
        }));
    }
    /**
     * 获取支持AI交易的交易对
     * @param market
     */
    requireAITradePairWithMarket(market) {
        return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/ai/get_pairs`, this.extraParamRuntime["commonParam"]), {
            "Content-Type": "application/json;charset=UTF-8",
        }, {
            exchange: market,
        }, (response) => {
            return response;
        })
            .pipe((0, operators_1.map)((result) => {
            if (result.code === 0) {
                return result.data;
            }
            else {
                return [];
            }
        }))
            .pipe((0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)([]);
        }));
    }
    userDefineGridFeeRate(orderId, setToExchange, feeRate) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.flatMap)((token) => {
            if (!token) {
                return (0, rxjs_1.of)(false);
            }
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/update_grid_fee_rate`, this.extraParamRuntime["commonParam"]), {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            }, {
                bu_order_id: orderId,
                set_to_exchange: setToExchange,
                fee_rate: feeRate,
            }, (response) => {
                return response.code;
            })
                .pipe((0, operators_1.map)((status) => {
                return status === 0;
            }))
                .pipe((0, operators_1.catchError)((err) => {
                return (0, rxjs_1.of)(false);
            }));
        }));
    }
    queryExchangeFeeRate(market, symbol) {
        if ((0, OrderDescUtils_1.checkMarketSupportV2Api)(this.apiKey.market)) {
            let queryUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost}/${this.apiKey.market}/spot/private/fee_rate/?symbol=${symbol || null}`;
            if ((0, Macro_1.isPionex)(this.apiKey.market)) {
                queryUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost}/sapi/v1/fee_rate/`;
            }
            return this.keyResolver.requestSigner.getSignRequestV2("GET", queryUrl, undefined).pipe((0, operators_1.map)((result) => {
                if (result.code === 0) {
                    return result.data[0].maker;
                }
                else {
                    return 0;
                }
            }));
        }
        else {
            return (0, trade_utils_lib_1.getTradeDependencyInstance)()
                .getAccessToken()
                .pipe((0, operators_1.flatMap)((token) => {
                if (!token) {
                    return (0, rxjs_1.of)(0);
                }
                return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/query_grid_fee_rate`, this.extraParamRuntime["commonParam"]), {
                    Authorization: token,
                    "Content-Type": "application/json;charset=UTF-8",
                }, {
                    exchange: market,
                }, (response) => {
                    return response;
                }).pipe((0, operators_1.map)((resp) => {
                    if (resp.code === 0) {
                        return resp.data.fee_rate;
                    }
                    return 0;
                }));
            }));
        }
    }
    getSymbolInfoObservable(base, quote) {
        return this._getSymbolPrecisionData(base, quote);
    }
    queryRestCCXTTicker(base, quote) {
        return this.querySymbolTickerPrice(base, quote);
    }
    querySymbolTicker(base, quote) {
        return this.queryTickerWithSymbolList([
            {
                market: this.apiKey.market,
                base: base.toUpperCase(),
                quote: quote.toUpperCase(),
            },
        ])
            .pipe((0, operators_1.map)((result) => {
            if (result && result.length > 0) {
                return result[0].latest;
            }
            return 0;
        }))
            .pipe((0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)(0);
        }));
    }
    requireAITradePairDetailWithMarket(market) {
        return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/ai/get_strategy`, this.extraParamRuntime["commonParam"]), {
            "Content-Type": "application/json;charset=UTF-8",
        }, {
            exchange: market,
        }, (response) => {
            return response;
        }).pipe((0, operators_1.map)((result) => {
            if (result.code === 0) {
                return result.data.map((item) => {
                    return {
                        base: item.base,
                        quote: item.quote,
                        picked: item.picked,
                        volume: "volume_to" in item ? item.volume_to : undefined,
                        annualized: item.annualized,
                    };
                });
            }
            else {
                return [];
            }
        }));
    }
    /**
     * AI广场-稳定币种
     * @param marketList
     */
    requireStableAIStrategyBatch(marketList) {
        return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/ai/stable_follow_square`, this.extraParamRuntime["commonParam"]), {
            "Content-Type": "application/json;charset=UTF-8",
        }, {
            exchange: marketList.join(","),
        }, (response) => {
            return response;
        }).pipe((0, operators_1.map)((result) => {
            if (result.code === 0) {
                return result.data.map((item) => {
                    return {
                        market: item.exchange,
                        base: item.base,
                        quote: item.quote,
                        picked: item.picked,
                        annualized: item.annualized,
                        volatility: item.volatility ? item.volatility : 0,
                    };
                });
            }
            else {
                return [];
            }
        }));
    }
    /**
     * AI广场-主流币种
     * @param marketList
     */
    requireMainStreamAIStrategyBatch(marketList) {
        return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/ai/mainstream_follow_square`, this.extraParamRuntime["commonParam"]), {
            "Content-Type": "application/json;charset=UTF-8",
        }, {
            exchange: marketList.join(","),
        }, (response) => {
            return response;
        }).pipe((0, operators_1.map)((result) => {
            if (result.code === 0) {
                return result.data.map((item) => {
                    return {
                        market: item.exchange,
                        base: item.base,
                        quote: item.quote,
                        picked: item.picked,
                        annualized: item.annualized,
                        volatility: item.volatility ? item.volatility : 0,
                    };
                });
            }
            else {
                return [];
            }
        }));
    }
    queryPionexFeeRate(base, quote) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/user_fee`;
        const fetchData = trade_utils_lib_1.ObservableUtils.get(url, { pair: `${base}_${quote}` }, undefined, true).pipe((0, operators_1.map)((r) => {
            return {
                makerFeeRate: r.maker_fee_rate,
                takerFeeRate: r.taker_fee_rate,
            };
        }));
        const modelParam = {
            keyId: this.apiKey.cloudKeyId,
            dataKey: `pionex_fee_rate_pair_${base}_${quote}`,
            expireTime: trade_utils_lib_1.EXPIRED_TYPE.NEVER,
            refresh: () => fetchData,
        };
        return (0, trade_utils_lib_1.getDataWithCache)(modelParam);
    }
    queryTradeLimit(minPrice, maxPrice, symbol) {
        if (!minPrice || !maxPrice) {
            return (0, rxjs_1.of)(0).pipe((0, operators_1.map)(() => {
                throw 'minPrice or maxPrice can not be "" or null or undefined';
            }));
        }
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/get-trade-limit`;
        const params = {
            min_price: minPrice,
            max_price: maxPrice,
            precision: {
                amount: symbol.amount,
                price: symbol.precision,
            },
            limits: symbol.limit,
        };
        return trade_utils_lib_1.ObservableUtils.post(url, JSON.stringify(params), null);
    }
    queryAipBackTest(base, quote, exchange) {
        return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/ai/aip_back_test`, this.extraParamRuntime["commonParam"]), {
            "Content-Type": "application/json;charset=UTF-8",
        }, {
            exchange: exchange,
            base: base,
            quote: quote,
        }, (response) => {
            return response;
        })
            .pipe((0, operators_1.map)((data) => {
            const parseData = data.data;
            if (parseData) {
                return parseData;
            }
            else {
                throw JSON.stringify(data) || `${data}`;
            }
        }))
            .pipe((0, operators_1.catchError)(() => {
            return (0, rxjs_1.of)(undefined);
        }));
    }
    queryAipLimit(symbol, exchange) {
        return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/get_aip_limits`, this.extraParamRuntime["commonParam"]), {
            "Content-Type": "application/json;charset=UTF-8",
        }, {
            exchange: exchange,
            base: symbol.base,
            quote: symbol.quote,
            market_info: {
                precision: {
                    amount: symbol.amount,
                    price: symbol.precision,
                },
                limits: symbol.limit,
            },
        }, (response) => {
            return response;
        })
            .pipe((0, operators_1.map)((data) => {
            const parseData = data.data;
            if (parseData) {
                return parseData;
            }
            else {
                throw JSON.stringify(data) || `${data}`;
            }
        }))
            .pipe((0, operators_1.catchError)(() => {
            return (0, rxjs_1.of)(undefined);
        }));
    }
    fetchFutureSpotFundingFeeRate() {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/funding_fee_rates/`;
        const fetchData = trade_utils_lib_1.ObservableUtils.get(url, undefined, undefined, false);
        const modelParam = {
            keyId: this.apiKey.cloudKeyId,
            dataKey: "fsa_funding_fee_rate",
            expireTime: trade_utils_lib_1.EXPIRED_TYPE.NEVER,
            refresh: () => fetchData,
        };
        return (0, trade_utils_lib_1.getDataWithCache)(modelParam);
    }
    fetchCoinMarginedFundingFeeRate() {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/coin_margined_funding_fee_rates/`;
        const fetchData = trade_utils_lib_1.ObservableUtils.get(url, undefined, undefined, false);
        const modelParam = {
            keyId: this.apiKey.cloudKeyId,
            dataKey: "cm_fsa_funding_fee_rate",
            expireTime: trade_utils_lib_1.EXPIRED_TYPE.NEVER,
            refresh: () => fetchData,
        };
        return (0, trade_utils_lib_1.getDataWithCache)(modelParam);
    }
    fsaRiskPlanStatus() {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/insurance_fund/`;
        return trade_utils_lib_1.ObservableUtils.getV2(url, null, null, true);
    }
    joinFSARiskPlan() {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/insurance_fund/join/`;
        return trade_utils_lib_1.ObservableUtils.postV2(url, null, null, true);
    }
    investFMCoin(param) {
        throw new Error("Method not implemented.");
    }
    queryFMCoinInvest(recordId) {
        throw new Error("Method not implemented.");
    }
    queryFMCoinRedeem(recordId) {
        throw new Error("Method not implemented.");
    }
    queryFMCoins(coin) {
        throw new Error("Method not implemented.");
    }
    queryFMInterestAggregate() {
        throw new Error("Method not implemented.");
    }
    queryFMInterestRecord(param) {
        throw new Error("Method not implemented.");
    }
    queryFMPositions() {
        throw new Error("Method not implemented.");
    }
    queryFMTransactions(param) {
        throw new Error("Method not implemented.");
    }
    redeemFMCoin(param) {
        throw new Error("Method not implemented.");
    }
    releaseFMInterest(param) {
        throw new Error("Method not implemented.");
    }
    /**
     * 查询MTG 当前挂单
     * @param orderId
     */
    queryMTGCurrentRound(orderId) {
        throw new Error("Method not implemented.");
    }
    /**
     * 查询多币MTG 当前挂单
     * @param orderId
     */
    queryMTGMultiModeCurrentRounds(orderId) {
        throw new Error("Method not implemented.");
    }
    /**
     * 查询MTG 历史挂单
     * @param param
     */
    queryMTGRoundList(param) {
        throw new Error("Method not implemented.");
    }
    /**
     * 根据id 查询order
     * @param orderId
     */
    queryBotOrderInfo(orderId) {
        throw new Error("Method not implemented.");
    }
    patchFSAAutoSettle(autoSettle, orderId) {
        throw new Error("Method not implemented.");
    }
    configureMartingaleStopPriceRange(orderId, base, range) {
        throw new Error("Method not implemented.");
    }
    setMartingaleStopPrice(orderId, base, modifyPriceType, modifyValue) {
        throw new Error("Method not implemented.");
    }
    requestMTGAIStrategyWithSymbol(base, quote) {
        throw new Error("Method not implemented.");
    }
    /**
     * 多币马丁AI参数
     * @param pairs
     */
    requestMTGMultiAIStrategyWithSymbols(pairs) {
        throw new Error("Method not implemented.");
    }
    /**
     * 多币马丁最小投资额
     * @param param
     */
    queryMTGMultiMinInvest(param) {
        throw new Error("Method not implemented.");
    }
    renewMartingale(orderId, base) {
        throw new Error("Method not implemented.");
    }
    modifyBotOrderNote(orderId, note) {
        throw new Error("Method not implemented.");
    }
    modifySRPriceInfo(param, orderId) {
        throw new Error("Method not implemented.");
    }
    setGridPause(orderId, orderType) {
        throw new Error("Method not implemented.");
    }
    setGridResume(orderId, orderType) {
        throw new Error("Method not implemented.");
    }
    queryGridMinAddPosition(param, orderType) {
        throw new Error("Method not implemented.");
    }
    queryGridPositionRecordList(orderId, orderType) {
        throw new Error("Method not implemented.");
    }
    queryOrderShareID(orderId) {
        throw new Error("Method not implemented.");
    }
    queryOrderShare(shareId) {
        throw new Error("Method not implemented.");
    }
    gridAdjustParams(param) {
        throw new Error("Method not implemented.");
    }
    /**
     * gridv4网格订单修改参数
     * @param param
     */
    gridV4AdjustParams(param) {
        throw new Error("Method not implemented.");
    }
    /**
     * 查询查询策略可用的信号
     */
    querySignalList(orderType, base, quote, signal_type) {
        throw new Error("Method not implemented.");
    }
    /**
     * 查询策略可用的信号
     */
    queryMultiCoinsSignalList(orderType, symbols, filter_option_all_symbols, signal_type) {
        throw new Error("Method not implemented.");
    }
    /**
     * 查询信号详情
     * @param signal_type
     */
    querySignalDetail(signal_type) {
        throw new Error("Method not implemented.");
    }
    queryVolatilityRank(param) {
        throw new Error("Method not implemented.");
    }
    /**
     * 查询KOL策略列表
     * @param lang
     * @param page_token
     * @param condition
     * @param category
     * @param enable_all_period
     * @param authorize
     */
    queryKolStrategy(lang, page_token, condition, category, enable_all_period, authorize) {
        throw new Error("Method not implemented.");
    }
    /**
     * 查询KOL策略信号列表
     * @param strategyId
     * @param page_token
     */
    queryKolStrategySignals(strategyId, page_token) {
        throw new Error("Method not implemented.");
    }
    /**
     * 查询KOL策略历史信号列表
     * @param strategyId
     * @param symbol
     * @param lang
     */
    queryKolStrategyHistorySignals(strategyId, symbol, lang) {
        throw new Error("Method not implemented.");
    }
    /**
     * 查询KOL策略信号详情
     * @param strategyId
     * @param lang
     * @param enable_all_period
     */
    queryKolStrategyDetail(strategyId, lang, enable_all_period) {
        throw new Error("Method not implemented.");
    }
    /**
     * 修改KOL信号通知 下面参数二选一
     * @param strategyId
     * @param signalId
     * @param bu_order_id
     * @param bu_order_type
     */
    updateStrategySignals(strategyId, signalId, bu_order_id, bu_order_type) {
        throw new Error("Method not implemented.");
    }
    /**
     * 订阅kol信号
     * @param strategyId
     * @param symbol
     */
    subscribeStrategySignals(strategyId, symbol) {
        throw new Error("Method not implemented.");
    }
    /**
     * 取消订阅kol信号
     * @param strategyId
     */
    unsubscribeStrategySignals(strategyId) {
        throw new Error("Method not implemented.");
    }
    /**
     *  更新kol 信号订阅币对
     * @param strategyId
     * @param symbol
     */
    updateSubscribeStrategySignals(strategyId, symbol) {
        throw new Error("Method not implemented.");
    }
    /**
     * 获取策略信号收益表现图表详情
     * @param strategyId
     * @param period
     */
    queryStrategyPerformance(strategyId, period) {
        throw new Error("Method not implemented.");
    }
    /**
     * 查询订阅信号详情
     * @param strategyId
     */
    queryStrategySubscriptionInfo(strategyId) {
        throw new Error("Method not implemented.");
    }
    /**
     * 查询特定的信号
     * @param strategyId
     * @param params
     */
    queryStrategySignal(strategyId, params) {
        throw new Error("Method not implemented.");
    }
    /**
     * 通过信号id查询定的信号
     * @param strategyId
     * @param signalId
     */
    queryStrategySignalById(strategyId, signalId) {
        throw new Error("Method not implemented.");
    }
    /**
     * 查询策略跟单历史交易记录
     * @param params
     */
    querySmartCopyRounds(params) {
        throw new Error("Method not implemented.");
    }
    /**
     * 修改网格的移动网格配置
     * @param params
     * @param orderId
     * @param orderType
     */
    modifyGridMovingOption(params, orderId, orderType) {
        throw new Error("Method not implemented.");
    }
}
exports.default = BaseTradingApi;
/**
 *
 * @param orderState 服务器原生状态 "prepare","open","pre-cancel","canceling","canceled","closed","error"
 * @param partialFilled 部分成交
 * filled:   （orderState === 'canceled' 且 部分成交） => 判定订单成交
 * canceled： error=> canceled
 *
 */
function convertState2(orderState, partialFilled) {
    if (orderState === "open" || orderState === "prepare") {
        return TradeTypeDef_1.ExchangeOrderStatus.submitted;
    }
    else if (orderState === "closed" || orderState === "partial_filled" || (orderState === "canceled" && partialFilled)) {
        return TradeTypeDef_1.ExchangeOrderStatus.filled;
    }
    else if (orderState === "pre-cancel" || orderState === "canceling") {
        return TradeTypeDef_1.ExchangeOrderStatus.canceling;
    }
    else {
        return TradeTypeDef_1.ExchangeOrderStatus.canceled;
    }
}
exports.convertState2 = convertState2;
function toSymbol(base, quote) {
    if (base && quote) {
        return base + "/" + quote;
    }
    else {
        return "";
    }
}
exports.toSymbol = toSymbol;
function queryTickerWithSymbolList(symbolList) {
    return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().extraParamRuntime["tickerHost"]}/get_tickers_index`, (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().extraParamRuntime["commonParam"]), undefined, JSON.stringify({
        mbq: symbolList,
    }), (response) => {
        return response.data;
    })
        .pipe((0, operators_1.map)((result) => {
        return result.map((tickerItem) => {
            return {
                base: tickerItem.base,
                quote: tickerItem.quote,
                latest: tickerItem.price,
                fiat: tickerItem.fiat,
                priceChange: tickerItem.change_percent,
                fullName: tickerItem.full_name,
            };
        });
    }))
        .pipe((0, operators_1.catchError)((err) => {
        return (0, rxjs_1.of)([]);
    }));
}
exports.queryTickerWithSymbolList = queryTickerWithSymbolList;
